import { Component, OnInit, ViewChild } from '@angular/core';
import { IonSelect } from '@ionic/angular';
import { ContactSocialComponent } from 'src/app/components/contact-social/contact-social.component';
import { BreadcrumbsService } from 'src/app/services/breadcrumbs.service';
import { HttpService } from 'src/app/services/http.service';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-contact-btn',
  templateUrl: './contact-btn.component.html',
  styleUrls: ['./contact-btn.component.scss'],
})
export class ContactBtnComponent implements OnInit {
  @ViewChild('selectBranch') selectBranch: IonSelect;
  public branches: any[] = [];
  private _domainId = environment.domainId;

  constructor(
    private _httpSv: HttpService,
    private _uiSv: UiServices,
    private _breadcrumbsSv: BreadcrumbsService,
    private _paramSv: ParamServicesService
  ) {}

  async ngOnInit() {
    const res = await this._httpSv.itemIndex('branchContact', '', {
      domainId: this._domainId,
      paginate: false,
    });
    this.branches = res.data;
  }

  async openBranch(select: IonSelect) {
    if (this.branches.length > 1) {
      select.open();
    } else {
      this.sendMessageToBranch(this.branches[0]);
    }
  }

  async sendMessageToBranch(ev) {
    const socials = ev?.detail?.value || ev;
    this._breadcrumbsSv.template;
    if (!socials.detail) {
      const { data } = await this._uiSv.showPopover(
        ContactSocialComponent,
        {
          socials,
          customMsg: `${this._paramSv.galleryContactMessage?.message} ${
            this._breadcrumbsSv.template[
              this._breadcrumbsSv.template.length - 1
            ]?.name
          }`,
        },
        'contact-social'
      );
      this.open(data);
      this.selectBranch.value = undefined;
    }
  }

  open(ev) {
    ev && window.open(ev, '_blank');
  }
}
